import { Observable, OperatorFunction, UnaryFunction, filter, pipe } from 'rxjs'

export function filterNull<T>():
    UnaryFunction<Observable<T | null>, Observable<T>> {
    return pipe(
        filter((a: T | null) => !!a) as
            OperatorFunction<T | null, T>
    )
}
